<template>
  <v-card flat :loading="loading">
    <v-card-title v-if="!hideSelections">
      <v-container fluid class="pa-0">
        <v-row align="center">
          <v-col cols="12" md="auto">
            <v-btn
              outlined
              left
              color="grey darken-2"
              :block="$vuetify.breakpoint.mobile"
              @click="setToday"
            >
              Today
            </v-btn>
          </v-col>
          <v-col cols="12" md="auto" class="text-center">
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              class="mx-2"
              @click="$refs.calendar.prev()"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </span>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              class="mx-2"
              @click="$refs.calendar.next()"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="auto">
            <v-select
              v-model="calendarType"
              :items="calendarTypes"
              solo
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-sheet :height="height">
        <v-calendar
          ref="calendar"
          v-model="currentDate"
          color="primary"
          :type="calendarType"
          :weekdays="calendarWeekdays"
          :events="events"
          first-time="08:00"
          interval-minutes="30"
          interval-count="28"
          @click:date="viewDay"
          @click:more="viewDay"
          @click:event="viewEvent"
        ></v-calendar>
        <event-menu
          v-model="eventMenu"
          :item="selectedEvent"
          :activator="eventElement"
          :color="selectedEvent.color"
          readonly
        ></event-menu>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>
<script>
import colorpalette from '@/colorpalette'
import EventMenu from '@components/ClassroomSchedule/EventMenu'
export default {
  name: 'ClassroomScheduleCalendarView',
  components: {
    EventMenu,
  },
  props: {
    schedules: {
      type: Array,
      default: () => [],
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    // showHeader: {
    //   type: Boolean,
    //   default: false,
    //   required: false,
    // },
    hideSelections: {
      type: Boolean,
      default: false,
      required: false,
    },
    type: {
      type: String,
      default: 'month',
      required: false,
    },
    showDetails: {
      type: Boolean,
      default: false,
      required: false,
    },
    height: {
      type: String,
      default: '800',
      required: false,
    },
  },
  data() {
    return {
      calendarWeekdays: [1, 2, 3, 4, 5, 6, 0], // Mon - Sun
      calendarTypes: ['month', 'week', 'day'],
      calendarType: this.type,
      currentDate: moment().format('YYYY-MM-DD'),
      eventMenu: false,
      eventElement: null,
      selectedEvent: {
        id: 0,
        classroom: {},
      },
    }
  },
  computed: {
    events() {
      return this.schedules.map((item) => ({
        id: item.id,
        name: item.classroom.name,
        start: moment(`${item.class_date}T${item.start_time}`).toDate(),
        end: moment(`${item.class_date}T${item.end_time}`).toDate(),
        timed: true,
        color: colorpalette[item.classroom_id % 99],
        classroom: item.classroom,
        classroom_id: item.classroom_id,
        class_date: item.class_date,
        start_time: item.start_time,
        end_time: item.end_time,
        term: item.term,
        month: item.month,
        session: item.session,
      }))
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$refs.calendar.checkChange()
  },
  methods: {
    init() {},
    setToday() {
      this.currentDate = moment().format('YYYY-MM-DD')
    },
    viewDay({ date }) {
      this.currentDate = date
      this.calendarType = 'day'
    },
    viewEvent({ event, nativeEvent }) {
      if (this.showDetails) {
        this.selectedEvent = event
        this.eventElement = nativeEvent.target
        this.eventMenu = true
      }
      this.$emit('click:event', event)
    },
  },
}
</script>
